// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import musicNote01Icon from "@/assets/icons/music-note-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type MusicNote01IconProps = Omit<IconProps, "name">;

export function MusicNote01Icon(props: MusicNote01IconProps): React.ReactNode {
  return <Icon name={musicNote01Icon} {...props} />;
}
